<template>
  <div>
    <label class="text-left block">
      <slot></slot>
    </label>
    <div v-if="(options instanceof Array)" class="items-start flex" :class="{
      'flex-row': alignment == 'row',
      'flex-col': alignment == 'col'
    }">
      <label class="mr-2 pr-2 mb-2.5" v-for="item in options" :value="item" :key="item">
        <input type="radio" :disabled="disabled" :value="item" v-model="model" />
        {{ item }}
      </label>
    </div>
    
    <div v-else class="items-start flex" :class="{
      'flex-row': alignment == 'row',
      'flex-col': alignment == 'col'
    }">
      <label class="mr-2 pr-2 mb-2.5" v-for="(val, key) in options" :key="key">
        <input type="radio" :disabled="disabled" :value="key" v-model="model" />
        {{ val }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: [],
    value: [],
    alignment: { type: String, default: 'row' },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>